
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { Settings, ImageSettings } from "@/Settings/Settings";

export default Vue.extend({

  data: () => ({
    partnerId: Settings.partner_id,
    subcatImageUrl: ImageSettings.baseSubcatUrl,
  }),
  computed: {
    ...mapState("items", ["categories", "subCategories"]),
    ...mapState("store", ["selectedStoreDetails"]),
  },
  methods: {
    ...mapActions("items", ["getCategories", "getSubCategories"]),
    ...mapActions("cusService", ["getInAppMsg"]),
  },
  mounted() {
    /** Getting list of categories */
  
    
  },



});
